import { PropositionProductTypeValues, PropositionStatusValues, PropositionStatus } from "@dune/types";

export const getPropositionOfferTypeLabel = (productType: PropositionProductTypeValues): string => {
	switch (productType) {
		case "DO":
			return "Offre Dommages Ouvrage";
		case "TRC":
			return "Offre Tous Risques Chantier";
		case "MRT":
			return "Offre Multi Risques Travaux";
		case "GFA":
			return "Offre Garantie Financière Achèvement";
		default:
			return "Offre";
	}
};

export const getPropositionOfferTypeBadgeColor = (productType: PropositionProductTypeValues): string => {
	switch (productType) {
		case "DO":
			return "bg-blue-50 text-blue-600 border-blue-200";
		case "TRC":
			return "bg-green-50 text-green-600 border-green-200";
		case "MRT":
			return "bg-purple-50 text-purple-600 border-purple-200";
		case "GFA":
			return "bg-orange-50 text-orange-600 border-orange-200";
		default:
			return "bg-gray-50 text-gray-600 border-gray-200";
	}
}; 

export const getPropositionStatusLabel = (status: PropositionStatusValues): string => {
    switch (status) {
        case PropositionStatus.NOUVEAU:
            return "Nouveau";
        case PropositionStatus.A_SIGNER:
            return "À signer";
        case PropositionStatus.SIGNEE:
            return "Signée";
        case PropositionStatus.SANS_SUITE:
            return "Sans suite";
        case PropositionStatus.CONTRACT_NEW:
            return "Nouveau contrat";
        case PropositionStatus.CONTRACT_TO_SIGN:
            return "À signer";
        case PropositionStatus.CONTRACT_ONGOING:
            return "En cours";
        case PropositionStatus.CONTRACT_WARRANTY:
            return "En garantie";
        case PropositionStatus.CONTRACT_TERMINATED:
            return "Résilié";
        default:
            return status;
    }
};

export const getPropositionStatusBadgeClasses = (status: PropositionStatusValues): string => {
    switch (status) {
        case PropositionStatus.NOUVEAU:
            return "text-blue-badge-text bg-blue-badge-background border-blue-badge-border";
        case PropositionStatus.A_SIGNER:
            return "text-orange-badge-text bg-orange-badge-background border-orange-badge-border";
        case PropositionStatus.SIGNEE:
            return "text-green-badge-text bg-green-badge-background border-green-badge-border";
        case PropositionStatus.SANS_SUITE:
            return "text-gray-badge-text bg-gray-badge-background border-gray-badge-border";
        case PropositionStatus.CONTRACT_NEW:
            return "text-blue-badge-text bg-blue-badge-background border-blue-badge-border";
        case PropositionStatus.CONTRACT_TO_SIGN:
            return "text-orange-badge-text bg-orange-badge-background border-orange-badge-border";
        case PropositionStatus.CONTRACT_ONGOING:
            return "text-green-badge-text bg-green-badge-background border-green-badge-border";
        case PropositionStatus.CONTRACT_WARRANTY:
            return "text-indigo-badge-text bg-indigo-badge-background border-indigo-badge-border";
        case PropositionStatus.CONTRACT_TERMINATED:
            return "text-red-badge-text bg-red-badge-background border-red-badge-border";
        default:
            return "text-gray-badge-text bg-gray-badge-background border-gray-badge-border";
    }
};

export const getClientPropositionStatusVariant = (status: string) => {
	switch (status) {
		case "NOUVEAU":
			return "secondary";
		case "EN_COURS":
			return "outline";
		case "SIGNE":
			return "default";
		case "ANNULE":
			return "destructive";
		default:
			return "secondary";
	}
};

export const getClientPropositionStatusLabel = (status: string) => {
	switch (status) {
		case "NOUVEAU":
			return "Nouveau";
		case "EN_COURS":
			return "En cours";
		case "SIGNE":
			return "Signé";
		case "ANNULE":
			return "Annulé";
		default:
			return status;
	}
};

export const getClientPropositionProductTypeLabel = (productType: string) => {
	switch (productType) {
		case "DO":
			return "Dommages Ouvrage";
		case "TRC":
			return "TRC";
		case "MRT":
			return "MRT";
		default:
			return productType;
	}
};
